import * as z from 'zod';

import { manufacturerQuerySchema } from './manufacturer-query-schema';

export const manufacturerUpdateSchema = manufacturerQuerySchema
  .omit({
    status: true,
    products_count: true,
  })
  .extend({
    status: z.string(),
  });

export type ManufacturerUpdateSchema = z.infer<typeof manufacturerUpdateSchema>;

export const manufacturerCreateSchema = manufacturerUpdateSchema.omit({ id: true });

export type ManufacturerCreateSchema = z.infer<typeof manufacturerCreateSchema>;
